export function backendUrl(path: string): string {
  const host = (import.meta.env.VITE_APP_BACKEND_HOST || '').replace(/\/+$/, '')
  return `${host}${path.startsWith('/') ? path : `/${path}`}`
}
